import { render, staticRenderFns } from "./courseresults.vue?vue&type=template&id=7dfc6512&scoped=true&"
import script from "./courseresults.vue?vue&type=script&lang=js&"
export * from "./courseresults.vue?vue&type=script&lang=js&"
import style0 from "./courseresults.vue?vue&type=style&index=0&id=7dfc6512&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc6512",
  null
  
)

export default component.exports